"use client"

import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { selectLanguage, selectUser } from "@/app/redux/store"

import ProjectCard from "../project-card/project-card"
import Label from "../label/Label"
import { getAllCurrentsProjectsByType, getAllUsersByPartner, getLabels, getPartner } from "@/app/adapters/api"
import { GridSkeleton } from "../../skeleton/gridSkeleton"
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Button } from "@/components/ui/button"
import Link from "next/link"

const labelsNames = [
  "preference-option-one", 
  "preference-option-two", 
  "preference-option-three", 
]

export default function HomeCurrentInvestmentsCarousel() {

  const [loading, setLoading] = useState(true)
  const [labels, setLabels] = useState<any>({})
  const lang = useSelector(selectLanguage)
  const userState = useSelector(selectUser)

  const [currentProjects, setCurrentProjects] = useState<any>([])
  const [availableCurrentProjects, setAvailableCurrentProjects ] = useState(0)
  const [projectTypeSelected, setProjectTypeSelected] = useState('all')
  const [skip, setSkip] = useState(0)
  const [limit, setLimit] = useState(5)

  useEffect(() => {
    getLabels(labelsNames)
      .then((response) => {
        setLabels(response.data.labels)
      })
      .finally(() => {
        setLoading(false)
      });
  }, [])

  useEffect(() => {
    loadProjects(projectTypeSelected)
  }, [projectTypeSelected])

  const loadProjects = async (projectType: string) => {
    setLoading(true)
    try {
      const response = await getAllCurrentsProjectsByType(projectType, skip, limit)
      const projectsIn = response.data.projects;
      const updatedProjects = await Promise.all(projectsIn.map(async (project: any) => {
        if (project?.exclusive === true && project?.status === 'precampaign' && userState.isLogin) {
          const partnerIds = project.projectPartners.map((partnerObj: any) => partnerObj.partner);
          const showResults = await Promise.all(partnerIds.map(async (partnerId: any) => {
            const partnerResponse = await getPartner(partnerId)
            const userResponses = await getAllUsersByPartner(partnerId, partnerResponse.data.partner.access)
            const partnerUsersIds = userResponses.data.partnerUsers.map((user: any) => user.partnerUser.id);
            const usersWithPartnerCodeIds = userResponses.data.usersWithPartnerCode.map((user: any) => user.id);
            const allUserPartners = [...partnerUsersIds, ...usersWithPartnerCodeIds];
            return allUserPartners.includes(userState.id);
          }));
          project.show = showResults.includes(true);
        } else {
          // if(project.status === 'accepted' || project.status === 'precampaign'){
            project.show = !project?.exclusive;
          // }
          
        }
        return project;
      }));
  
      const filteredProjects = updatedProjects.filter((project: any) => project.show);
      setCurrentProjects(filteredProjects)
      setAvailableCurrentProjects(response.data.totalProjects)
      const newSkip = skip + limit;
      setSkip(newSkip)
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false)
    }
  };

  const handleSelectProjectType = (projectType: string) => {
    setSkip(0);
    setProjectTypeSelected(projectType)
  }

  const handleAddProjects = () => {
    getAllCurrentsProjectsByType(projectTypeSelected, skip, limit)
      .then((response) => {
        const newProjects = [...currentProjects, ...response.data.projects]
        setCurrentProjects(newProjects)
        setAvailableCurrentProjects(response.data.totalProjects)
        const newSkip = skip + limit;
        setSkip(newSkip)
      })
      .finally(() => {
        setLoading(false)
      });
  }

  return (
    <section className="my-4">
      {
        loading ?
        <GridSkeleton />
        :
        <>
          <div className="px-2 md:px-16 max-w-[1200px] mx-auto pb-4">
            <Carousel opts={{
                    align: "center",
                  }}
              >
              <CarouselContent>
                  {currentProjects.map((project: any) => {
                    return (
                    <CarouselItem key={project.id} className="lg:basis-1/2 xl:basis-1/3 flex justify-center gap-2">
                      <ProjectCard projectId={project.id} lang={lang}/>
                    </CarouselItem>
                    ) 
                  })}
              </CarouselContent>
              <CarouselPrevious />
              <CarouselNext />
            </Carousel>
          </div>
          <div className="px-2 md:px-16 max-w-[1200px] mx-auto mt-4 flex justify-center md:justify-end">
            {
              lang === 'en' ?
              <Link href="/investment-opportunities">
                <Button variant={"orange"}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SEE MORE&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Button>
              </Link>
              :
              <Link href="/oportunidades-inversion/">
                <Button variant={"orange"}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;VER MÁS&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Button>
              </Link>
            }
          </div>
        </>
      }
    </section>
  )
}
